import React, { useEffect, useRef, useState } from 'react'
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import styles from "./Document.module.css";
import IssuerNavigator from '../../components/DashBoard/IssuerNavigator'
import style from "../DashBoard/CompanyProfile.module.css";
import templateStyles from "../DashBoard/Templates/Templates.module.css";
import { _ToNormal, AuthConsole, convertDateFormat, parseBlobError, setDate } from '../../Utils/helper';

import Pagination from './ExternalDash/Pagination';
import API from "../../ApiConfig";
import { BASE_URL, EXPORT_REQUESTS, GET_ALL_COMPANIES, GET_APPEALS, USER_TOKEN } from '../../Utils/constant';
import ShimmerLoader from '../../components/ShimmerLoader';

import CustomDropDown from '../../components/CustomDropDown';
import { useNavigate } from 'react-router-dom';
import useRefreshToken from '../../Hooks/usegenerateToken';





import dropdownStyle from "../DashBoard/ExternalDash/Verifier/VerifyUsers.module.css";
import Dropdown from './Dropdown';
import SearchDropdown from './ExternalDash/Employment/searchDropdown';
import PageSizeSelector from '../../Utils/PageSizeSelector';
import appealStyles from "./GlobalAppeals.module.css";
import filterStyles from "./FilterBar.module.css";
import cogoToast from 'cogo-toast-react-17-fix';
const GlobalAppeals = () => {

    useRefreshToken(BASE_URL + USER_TOKEN)

    const [loading, setLoading]=useState(false)
    const [currentRecords, setCurrentRecords]=useState([])
    const [search, setSearch]=useState("");
    const [currentPage, setCurrentPage]=useState(1)
    const Status=["all_appeals", "appeals_pending_on_issuer", "appeals_approved", "appeals_denied","appeals_issuer_added_different_value"]
    const [selectedValue, setSelectedValue]=useState("all_appeals")
    const [totalPages, setTotalPages]=useState(1)
    const [verifiername, setVerifierName]=useState({
            "id": 0,
            "name": "Select Verifier",
            "issuers": [],
            "verifiers": []})
    const [verifierList, setVerifierList]=useState([])
    const [company, setCompany]=useState({ 
      "id": 0,
      "name": "Select Issuer",
      "issuers": [],
      "verifiers": []})

      const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
    const [companiesList, setCompaniesList]=useState([])
    const[pageSize, setPageSize]=useState(10)
    const [sortBy, setSortBy]=useState({
      key:"created_at",
      direction:"desc"
    })
    const navigate=useNavigate()
  const handleAppeals=()=>{
    setLoading(true)
    API.get(`${GET_APPEALS}`,{
      params:{
        status:selectedValue,
        verifier_company_id:verifiername?.id,
        issuer_company_id:company?.id,
        page:currentPage,
        sort_by:sortBy.key,
        search:search,
        sort_order:sortBy.direction,
        per_page:pageSize
      }
    })
    .then(res=>{
      if(res.data.status===200){
      setLoading(false)
      setCurrentRecords(res.data.data.items)
      setTotalPages(res.data.data.total_pages)
      }

    })
    .catch(err=>{
      setLoading(false)
      AuthConsole(err);
      
    })
  }
  const SortList=(sort)=>{
    let direction = "asc";

    if (sortBy.key === sort && sortBy.direction === "asc") {
        direction = "desc";
    }
    const newSortBy = { key:sort, direction }

    setSortBy(newSortBy)
  }
  const getAllCompanies_issuer = () => {
    setLoading(true);
    API.get(GET_ALL_COMPANIES + `?company_type=Issuer&status=${selectedValue=="all_appeals"?"":selectedValue}`)
      .then((res) => {
        if (res.data.status == 200) {
          setLoading(false);
          setCompaniesList(res?.data?.data);
        }
      })

      .catch((err) => {
        setLoading(false);
        AuthConsole(err);
      });
  };

  const getAllCompanies_verifier = () => {
    setLoading(true);
    API.get(GET_ALL_COMPANIES + `?company_type=verifier&status=${selectedValue=="all_appeals"?"":selectedValue}`)
      .then((res) => {
        if (res.data.status == 200) {
          setLoading(false);
          setVerifierList(res?.data?.data);
        }
      })

      .catch((err) => {
        setLoading(false);
        AuthConsole(err);
      });
  }
  const handleSelect = (selectedItem, type) => {
    if (type === "Verifier") {
      setVerifierName(selectedItem);
    } else if (type === "Issuer") {
      setCompany(selectedItem);

    }
  }



  useEffect(()=>{
    getAllCompanies_issuer()
    getAllCompanies_verifier()
  },[selectedValue])
    const handleSearch=(e)=>{
      setSearch(e)
      setCurrentPage(1)
    }
    useEffect(()=>{
      const delayDebounce=setTimeout(()=>{
        handleAppeals()

      },500)
      return ()=>clearTimeout(delayDebounce)
      
    },[search,selectedValue,company, verifiername, currentPage, sortBy, pageSize])
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    }
    const handleNavigate=(i)=>{
      navigate(`/company/2/${i.verifier_id}/doc_descrepency_details/${i.id}`)
  }

  // console.log(companiesList);
  
  
  const handlePageSize=(newSize)=>{
    setPageSize(newSize)
    setCurrentPage(1)
  }

  const handleDownload = async (e) => {
      e.preventDefault();
  
      setLoading(true);
      if (dateRange.startDate !== "" && dateRange.endDate !== "") {
        const apiData = {
          issuer_company_id: company?.id,
          verifier_company_id: verifiername?.id,
  
          // Prefix with "appeals_" so the shared export endpoint filters on the
          // Appeal-status namespace instead of VerificationRequestStatus.
          status: `appeals_${selectedValue}`,
          start_date: convertDateFormat(dateRange.startDate),
          end_date: convertDateFormat(dateRange.endDate),
        };
  
        API.post(EXPORT_REQUESTS, apiData, { responseType: "blob" })
          .then((res) => {
            if (res.status == 200) {
              setDateRange({ startDate: "", endDate: "" });
              setCompany({});
              setVerifierName({})
              handleAppeals();
              const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
  
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
  
              link.href = url;
              link.download = `${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
              document.body.appendChild(link);
              link.click();
  
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
          })
          .catch(async (err) => {
            cogoToast.error(await parseBlobError(err));
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
        cogoToast.error("Enter Valid Start and End Date");
      }
    }
    const handleDateChange = (field, e) => {
      setDateRange((prev) => ({ ...prev, [field]: e }));
    }
  return (
    <SlideUpWrapper direction="slide-left">
            <div className={[style.companyProfile, templateStyles.templateHeader].join(" ")}>
            <IssuerNavigator
                    title="Global Appeals"
                    actions={() =><></>
                    } step={'/'} />
            </div>
            <div style={{margin:"1rem"}}>
              <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "right",
                                        margin: "10px 0px",
                                      }}
                                    >
                                      <button
                            className="btn btn-primary"
                            onClick={(e) => handleDownload(e)}
                          >
                            Export
                          </button>
                                    </div>
              <div className={filterStyles.filterBar}>
                <div className={`inputField2 ${filterStyles.searchField}`}>
                  <div className="input1">
                    <div className="content1">
                      <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                      <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                    </div>
                  </div>
                </div>
                <div className={filterStyles.selectFilter}>
                  <SearchDropdown apidata={companiesList} displayKey="name" placeholder='Select Issuer...' onSelect={(e)=>{setCompany(e);setCurrentPage(1)}} width='100%'/>
                </div>
                <div className={filterStyles.selectFilter}>
                  <SearchDropdown apidata={verifierList} displayKey="name" placeholder='Select Verifier...' onSelect={(e)=>{setVerifierName(e);setCurrentPage(1)}} width='100%'/>
                </div>
                <input
                  type="date"
                  className={style.datePicker}
                  value={dateRange.startDate}
                  onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                />
                <input
                  type="date"
                  className={style.datePicker}
                  value={dateRange.endDate}
                  onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                />
                <div className={filterStyles.statusFilter}>
                  <CustomDropDown list={Status} selectedOption={selectedValue} onSelect={(e)=>setSelectedValue(e)} width='100%'/>
                </div>
              </div>
            </div>
             <div className={`credentials-table ${appealStyles.appealsTable}`} style={{height:"115vh"}}>
                         <table style={{ borderRadius: "10px" }}>
                           <tr className="credentials-header bg-lgray">
             
                             <th className="credentials-th">
                               <div className="credentials-table-text">Search ID</div>
                             </th>

                             <th className="credentials-th">
                               <div className="credentials-table-text">Emp ID</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">Candidate Name</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text" style={{display:"flex", gap:"4px"}}>
                                <div>Raised On</div>
                                 <div className={styles.dropdown} style={{cursor:"pointer"}} onClick={(e)=>SortList("created_at")}>
                                    <img className={styles.chevronSortIcon} alt="" src="/chevronsort.svg"/>
                                  </div>
                                </div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">Issuer</div>
                             </th>
             
                             <th className="credentials-th">
                               <div className="credentials-table-text">Verifier</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">On Behalf Of</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">Verifier Remarks</div>
                             </th>
                             <th className='credentials-th'>
                                <div className='credentials-table-text'>Issuer Remarks</div>
                             </th>
                             <th className="credentials-th">
                               <div className="credentials-table-text">Request Status</div>
                             </th>
                             <th className='credentials-th'>
                                <div className='credentials-table-text'>Action</div>
                             </th>
             
                           </tr>
                           {loading ? <>
                             {Array.from({ length: 2 }).map((_, row) => (
                               <tr className="credentials-tr" key={`shimmer-${row}`}>
                                 {Array.from({ length: 11 }).map((__, col) => (
                                   <td className="credentials-td" key={col}>
                                     <div className="credentials-table-text1"><ShimmerLoader width='100%' height='1.5rem' /></div>
                                   </td>
                                 ))}
                               </tr>
                             ))}
                           </> : currentRecords.length === 0 ?
                             <tr className="credentials-tr">
                               <td colSpan="11" className="credentials-td text-center">
                                 <div className="Data_List">No Appeal Records</div>
                               </td>
                             </tr>
                             :
                             <>
                               {currentRecords.map((i, index) => {
                                 return (
                                   <tr className="credentials-tr" style={{ animationDelay: `${index * 0.01}s` }}>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{i.id}</div>
                                     </td>

                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{i?.employee_id}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{i?.name}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{setDate(i.created_at)}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{i.issuer_company}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{i.verifier_company}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1">{i.on_behalf_of_company_name}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className="credentials-table-text1 Remarks" title={i.verifier_remarks}>{i.verifier_remarks}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className={`credentials-table-text1 ${i.issuer_remarks?"Remarks":""}`} title={i.issuer_remarks}>{i.issuer_remarks || "NA"}</div>
                                     </td>
                                     <td className="credentials-td">
                                       <div className={`credentials-table-text1 ${i.status=="APPROVED"?"Complete":i.status=="ISSUER_ADDED_DIFFERENT_VALUE"?"Initiated":i.status=="DENIED"?"Rejected":"Pending"}`} >{i.status.replace(/_/g, " ")}</div>
                                     </td>
                                     <td className="credentials-td Action-row">
                                       <button className={"btn btn-primary"} onClick={()=>handleNavigate(i)}>View</button>
                                     </td>
                                   </tr>)
                               })}
                             </>}
                         </table>

                         <div style={{ margin: "10px" }}>
                          <PageSizeSelector value={pageSize} onChange={handlePageSize}/>
                            <Pagination
                                nPages={totalPages}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                onPageChange={handlePageChange}
                                loading={loading}
                            />
                        </div>
                       </div >
    </SlideUpWrapper>
  )
}

export default GlobalAppeals